/**
 * The Kanban board's cards, built from the store's tasks. Free of Vue and DHTMLX so it can be unit-tested.
 *
 * The board mutates the card objects it holds (a move sets the card's column in place), so a reload
 * after a refused move must use cards built fresh from the store, never the ones handed to the board.
 */

/**
 * @param {Array<object>} tasks the store's tasks (TASK/GET_TASKS); left untouched
 * @param {Array<{id: string}>} kanbanUsers the board users ({ id, label, avatar })
 * @returns {Array<object>} new card objects in Kanban order
 */
export function buildKanbanCards(tasks, kanbanUsers) {
  return [...tasks]
    .sort((a, b) => a.kanbanOrder - b.kanbanOrder)
    .map((task) => {
      const participants = task.participants || [];
      return {
        ...task,
        participants,
        users: [
          ...participants
            .map((participant) => kanbanUsers.find((user) => user.id == participant.userId))
            .filter((user) => user),
          // Kept as it was: this compares a user to itself, so it never finds the reporter.
          kanbanUsers.find((user) => user.id == user.reportedById),
        ],
      };
    });
}
